<template>
  <div id="footer" class="d-flex border-common px-2">
    <div
      class="flex-shrink-1 flex-grow-1 text-truncate pr-2"
      v-on:click="showFooterMessageLogs"
    >
      {{ $_latestMessage }}
    </div>
    <div class="flex-shrink-0 flex-grow-0 align-center">
      <v-btn text x-small v-on:click="showHelp">Help(h)</v-btn>
      <text-divider content="-"></text-divider>
      <v-btn text x-small v-on:click="showVersion">{{ toolTitle }}({{ version }})</v-btn>
    </div>
  </div>
</template>

<style scoped>
#footer {
  user-select: none;
  line-height: 24px;
  border-top-width: 1px;
  border-top-style: solid;
  font-size: 0.8em;
}
</style>

<style src="../styles/common.css" scoped></style>

<script>
import TextDivider from './Parts/TextDivider.vue';

class FooterMessages {
  static name = 'FooterMessages';

  static Message = class {
    static name = 'Message';

    constructor(data, time) {
      this.data = data;
      this.time = time;
    }

    toString() {
      return this.data;
    }

    toLogString() {
      return `[${this.time.toLocaleString()}]: ${this.data}`;
    }
  }

  constructor(...args) {
    this.data = new Array(...args);
  }

  push(message) {
    this.data.push(new FooterMessages.Message(message, new Date()));
  }

  get latestMessage() {
    if (this.data.length === 0) return '';
    return this.data[this.data.length - 1];
  }

  get logMessages() {
    return this.data.map(message => message.toLogString());
  }
}

export { FooterMessages };

export default {
  components: {
    TextDivider,
  },

  props: {
    toolTitle: { type: String },
    messages:  { type: FooterMessages },
    version:   { type: String },
  },

  computed: {
    $_latestMessage() {
      return this.messages.latestMessage;
    },
  },

  inject: [
    'showHelp',
    'showVersion',
    'showFooterMessageLogs',
  ],
};
</script>
